













































import {
  Component,
  Emit,
  Model,
  Prop,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import Nav from "@/components/nav/navBar.vue";
import * as types from "@/store/constants/types";
import VideoPlayer from "@/components/videoPlayer/videoPlayer.vue";
import EventBus from "@/utils/eventBus";
import SuperPayAndBackUpHelpers, {
  TEMP_KEY,
  LOCAL_KEY
} from "@/utils/superPayAndBackUp";
import BakcPress from "@/utils/backPress";
import { versionGreaterThan, isSupportLocalFiles } from "@/utils/judgeVersion";
import { sendEvent, sendEventWithParams } from "@/utils/analytics";

@Component({
  components: {
    Nav,
    VideoPlayer
  }
})
export default class SuperPayLaunch extends Vue {
  @Action(types.ROUTER_GO_BACK)
  private routerGoBack: any;
  @Getter(types.GETTER_SUPER_PAY_PARAMS)
  private superPayAppParams: any;
  @Action(types.ROUTER_REPLACE)
  private routerReplace: any;
  @Action(types.FETCH_VIDEO_URL_BY_DICT)
  private getVideoURL: any;
  @Action(types.START_INSTALL_SUPER_PAY_APP)
  private startInstallSuperPayApp: any;
  @Action(types.SHOW_FREE_FOLLOWERS)
  private showFreeFollowers: any;

  private videoSrc: string = "";
  private videoShow: boolean = false;
  private delayTimer: any = null;
  private videoTimer: any = null;

  private isJumped: boolean = false;

  get isSupportLocalFiles() {
    return isSupportLocalFiles();
  }

  // get posterSrc() {
  //   return require("@/assets/icons-file/super_pay/face_quiet.jpg");
  // }

  private created() {
    BakcPress.listen({
      key: this.$route.name,
      fn: () => {
        this.clickSkip();
      }
    });
  }

  private async videoInit() {
    if (this.isSupportLocalFiles) {
      this.videoSrc = await this.getVideoURL(
        this.superPayAppParams.video_files.launch_page
      );
      this.videoShow = true;
    } else {
      this.delayTimer = setTimeout(() => {
        this.clickSkip();
        clearTimeout(this.delayTimer);
      }, 3500);
    }
  }

  private videoReady() {
    // clearTimeout(this.videoTimer);
    // this.videoShow = true;
  }

  private async mounted() {
    SuperPayAndBackUpHelpers.addLocalKeyTimes(
      LOCAL_KEY.SUPER_PAY_PAY_LAUNCH_SHOW_TIMES
    );

    this.videoInit();
  }

  private clickSkip(type: string = "click") {
    if (this.isJumped) {
      return;
    }

    this.routerGoBack(-1);

    //触发toast
    this.showLaunchToast();

    clearTimeout(this.delayTimer); //清除定时器

    BakcPress.destroy(this.$route.name as any);

    if (type === "click") {
      sendEvent("uia_launch_ad_page", "skip_click");
    }
  }

  private showLaunchToast() {
    EventBus.$emit("show-super-pay-launch-toast", {
      show: true
    });
  }

  private continusLogic() {
    this.showFreeFollowers();
  }

  private endedVideo() {
    setTimeout(() => {
      this.clickSkip("endedVideo");
    }, 500);
    sendEvent("uia_launch_ad_page", "ad_play_completed");
  }

  private clickGet() {
    this.isJumped = true;
    console.log("clickGet");
    this.startInstallSuperPayApp({
      ga: "uia_launch_ad_page"
    });
    // 然后执行后面的弹窗逻辑：
    this.routerGoBack(-1);
    this.continusLogic();
    clearTimeout(this.delayTimer); //清除定时器
    BakcPress.destroy(this.$route.name as any);

    sendEvent("uia_launch_ad_page", "ad_click");
  }
}
